(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mj-site-header"]) return;
  try {
    
  (() => {
    const body = document.body;
    const drawer = document.querySelector('[data-mj-mobile-menu]');
    const overlay = document.querySelector('[data-mj-menu-overlay]');
    const openButton = document.querySelector('[data-mj-menu-toggle]');
    const closeButton = document.querySelector('[data-mj-menu-close]');
    const closeMenu = () => {
      if (!drawer || !overlay || !openButton) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      overlay.hidden = true;
      body.classList.remove('mj-menu-open');
    };
    const openMenu = () => {
      if (!drawer || !overlay || !openButton) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      overlay.hidden = false;
      body.classList.add('mj-menu-open');
      closeButton?.focus();
    };
    openButton?.addEventListener('click', openMenu);
    closeButton?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeMenu();
    });

    document.addEventListener('click', event => {
      const lightboxOpen = event.target.closest('[data-mj-lightbox-open]');
      if (lightboxOpen) {
        const gallery = lightboxOpen.closest('[data-mj-gallery]');
        const mainImage = lightboxOpen.querySelector('[data-mj-gallery-image]');
        const lightbox = gallery?.querySelector('[data-mj-lightbox]');
        const lightboxImage = lightbox?.querySelector('[data-mj-lightbox-image]');
        if (mainImage && lightbox && lightboxImage) {
          lightboxImage.src = mainImage.currentSrc || mainImage.src;
          lightboxImage.alt = mainImage.alt;
          if (typeof lightbox.showModal === 'function') lightbox.showModal();
          else lightbox.setAttribute('open', '');
        }
      }
      const lightboxClose = event.target.closest('[data-mj-lightbox-close]');
      if (lightboxClose) {
        const lightbox = lightboxClose.closest('[data-mj-lightbox]');
        if (typeof lightbox?.close === 'function') lightbox.close();
        else lightbox?.removeAttribute('open');
      }
      if (event.target.matches('[data-mj-lightbox]')) {
        if (typeof event.target.close === 'function') event.target.close();
        else event.target.removeAttribute('open');
      }
      const quantityButton = event.target.closest('[data-mj-quantity-action]');
      if (quantityButton) {
        const wrapper = quantityButton.closest('[data-mj-quantity]');
        const input = wrapper?.querySelector('[data-mj-quantity-input]');
        const value = wrapper?.querySelector('[data-mj-quantity-value]');
        if (!input) return;
        const step = quantityButton.dataset.mjQuantityAction === 'increase' ? 1 : -1;
        const minimum = Number(input.min || 1);
        input.value = Math.max(minimum, Number(input.value || minimum) + step);
        if (value) value.textContent = input.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('change', event => {
      const select = event.target.closest('[data-mj-variant-select]');
      if (!select) return;
      const selected = select.options[select.selectedIndex];
      const scope = select.closest('[data-mj-product-form]');
      const idInput = scope?.querySelector('[name="id"]');
      const productInfo = scope?.closest('.mj-product-info');
      const price = productInfo?.querySelector('[data-mj-product-price]');
      const addButton = scope?.querySelector('[data-mj-add-button]');
      const stockLabel = productInfo?.querySelector('[data-mj-stock-label]');
      const stockDot = productInfo?.querySelector('.mj-product-info__dot');
      if (idInput) idInput.value = selected.value;
      if (price) price.textContent = selected.dataset.price || price.textContent;
      if (addButton) {
        const available = selected.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldoutLabel;
        if (stockLabel) stockLabel.textContent = available ? stockLabel.dataset.instockLabel : stockLabel.dataset.soldoutLabel;
        stockDot?.classList.toggle('is-unavailable', !available);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
